require('videogular');
require('./vg-buffering');

module.exports = 'com.2fdevs.videogular.plugins.buffering';



// WEBPACK FOOTER //
// ./node_modules/videogular-buffering/index.js